let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7zMjZ"), load("a1dBM"), load("68Kzv"), load("3NvtU"), load("57lQ2")]).then(() => parcelRequire('aSeFh'));